<template>
  <div>
    <el-table :data="tigerList" size="small" height="calc(100vh - 326px)">
      <el-table-column prop="userId" label="用户UID" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.userId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channelUserId" label="合伙人UID" width="160">
        <template slot-scope="scope">
          <span>{{ scope.row.channelUserId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="positionId" label="仓位ID" width="180">
      </el-table-column>

      <el-table-column prop="" label="交易手续费汇总" width="180">
        <template slot-scope="scope">
          <span>{{ scope.row.fee }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="type" label="风控原因" min-width="190">
        <template slot-scope="scope">
          <span v-if="scope.row.type == 1">40秒内订单</span>
          <span v-if="scope.row.type == 2"
            >三分三十秒内订单数量大于等于总订单数据的50</span
          >
          <span v-if="scope.row.type == 3"
            >三分三十秒内交易金额大于等于总交易金额的50</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="" label="创建时间" width="180">
        <template slot-scope="scope">
          {{ scope.row.createdTime | moment }}
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import moment from 'moment'
import Pagination from 'components/pagination'
export default {
  data() {
    return {}
  },
  components: {
    Pagination,
  },
  methods: {
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('rebateRisk', ['pagination', 'tigerList', 'totalCount']),
  },
}
</script>

<style lang="less" src="../../../../styles/table.less" scoped></style>
